if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        requestAnimationFrame(() => {
          const selectedVariant = this.getSelectedVariant(this);
          if (selectedVariant) {
            this.filterVariantImages(selectedVariant);
            this.updateSelectedColor(selectedVariant);
          }
        });
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }



  handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);
          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

    
          this.querySelectorAll('.variant-hidden, .doli-hide-image').forEach((item) => {
            item.classList.remove('variant-hidden', 'doli-hide-image');
            item.style.setProperty("display", "block", "important");
          });

          this.updateMedia(html, variant?.featured_media?.id);
          const galleryViewer = this.querySelector('[id^="GalleryViewer-"]');
          if (galleryViewer && typeof galleryViewer.resetPages === 'function') {
            try { galleryViewer.resetPages(); } catch(e) { console.log("Slider Reset safely bypassed."); }
          }
          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };
          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));
          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: { sectionId: this.sectionId, html, variant },
          });
          
    
          this.filterVariantImages(variant);
          this.updateSelectedColor(variant);
        };
      }



      
        //Live 
      // handleUpdateProductInfo(productUrl) {
      //   return (html) => {
      //     const variant = this.getSelectedVariant(html);
      //     this.pickupAvailability?.update(variant);
      //     this.updateOptionValues(html);
      //     this.updateURL(productUrl, variant?.id);
      //     this.updateVariantInputs(variant?.id);

      //     if (!variant) {
      //       this.setUnavailable();
      //       return;
      //     }

      //     this.updateMedia(html, variant?.featured_media?.id);
         
      //     const galleryViewer = this.querySelector('[id^="GalleryViewer-"]');
      //     if (galleryViewer && typeof galleryViewer.resetPages === 'function') {
      //       galleryViewer.resetPages();
      //     }

      //     const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
      //       const source = html.getElementById(`${id}-${this.sectionId}`);
      //       const destination = this.querySelector(`#${id}-${this.dataset.section}`);
      //       if (source && destination) {
      //         destination.innerHTML = source.innerHTML;
      //         destination.classList.toggle('hidden', shouldHide(source));
      //       }
      //     };

      //     updateSourceFromDestination('price');
      //     updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
      //     updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
      //     updateSourceFromDestination('Volume');
      //     updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

      //     this.updateQuantityRules(this.sectionId, html);
      //     this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
      //     this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

      //     this.productForm?.toggleSubmitButton(
      //       html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
      //       window.variantStrings.soldOut
      //     );

      //     publish(PUB_SUB_EVENTS.variantChange, {
      //       data: {
      //         sectionId: this.sectionId,
      //         html,
      //         variant,
      //       },
      //     });
      //     this.filterVariantImages(variant);
      //     this.updateSelectedColor(variant);
      //   };
      // }

      // filterVariantImages(variant) {
      //   if (!variant) return;
      //   if (this.dataset.menProduct !== "true") return;
      //   const optionValues = variant.options.map(v =>
      //     v.toLowerCase().replace(/\s+/g, "-")
      //   );
      //   const variantKey = optionValues.join("-"); // red-s
      //   const mediaItems = this.querySelectorAll("media-gallery li[data-media-id].list_media");
      //   mediaItems.forEach(item => {
      //     const img_alt = item.getAttribute('data-variant-media')?.toLowerCase().replace(/\s+/g, "-");
      //     console.log("variantKey:", variantKey);
      //     console.log("img_alt:", img_alt);
      //     if (img_alt === variantKey) {
      //       item.style.display = "";
      //     } else {
      //       item.style.display = "none";
      //     }
      //   });
      // }



filterVariantImages(variant) {
        if (!variant) return;
        let colorOption = variant.options[0]; 
        const colorInput = this.querySelector('input[type="radio"][name*="olor"]:checked, input[type="radio"][name*="olour"]:checked');
        if (colorInput) colorOption = colorInput.value;
        
        if (!colorOption) return;
        const matchColor = colorOption.toLowerCase().replace(/[\s-]/g, '');


        const allColorRadios = Array.from(this.querySelectorAll('input[type="radio"][name*="olor"], input[type="radio"][name*="olour"]'));
        const allColorsList = allColorRadios.map(radio => radio.value.toLowerCase().replace(/[\s-]/g, ''));

        const mediaGallery = this.querySelector("media-gallery");
        if (!mediaGallery) return;

        const mediaItems = mediaGallery.querySelectorAll("li.product__media-item, li.list_media, li[data-media-id]");
        let visibleMediaIds = [];
        let featuredItemMediaId = variant.featured_media ? variant.featured_media.id.toString() : null;

        mediaItems.forEach((item) => {
            let mediaData = item.getAttribute("data-variant-media") || item.querySelector("img")?.getAttribute("alt") || "";
            const normalizedAlt = mediaData.toLowerCase().replace(/[\s-]/g, '');
            const sortedColors = [...new Set(allColorsList)].sort((a, b) => b.length - a.length);
            const matchAlt = sortedColors.find(color => normalizedAlt.startsWith(color)) || "";
            const itemMediaId = item.getAttribute("data-media-id");

            // Check  Alt text name
            const containsAnyColor = matchAlt !== "";

            // 👇👇👇 TEMP FIX START 👇👇👇
            
            if (!containsAnyColor) {
                if (itemMediaId) visibleMediaIds.push(itemMediaId);
            } 
            // 👆👆👆 TEMP FIX END 👆👆👆
 
            else if (matchAlt === matchColor) {
                if (itemMediaId) visibleMediaIds.push(itemMediaId);
            }
        });


        if (visibleMediaIds.length === 0) {
            let fallbackId = null;
            if (featuredItemMediaId) {
                const featuredItem = Array.from(mediaItems).find(item => item.getAttribute("data-media-id")?.includes(featuredItemMediaId));
                if (featuredItem) fallbackId = featuredItem.getAttribute("data-media-id");
            }
            if (!fallbackId && mediaItems.length > 0) fallbackId = mediaItems[0].getAttribute("data-media-id");
            if (fallbackId) visibleMediaIds.push(fallbackId);
        }


        mediaItems.forEach((item) => {
            const itemMediaId = item.getAttribute("data-media-id") || "";
            if (visibleMediaIds.some(id => itemMediaId.includes(id))) {
                item.style.setProperty("display", "block", "important");
                item.classList.remove("variant-hidden");
            } else {
                item.style.setProperty("display", "none", "important");
                item.classList.add("variant-hidden");
            }
        });

        const thumbnails = this.querySelectorAll("thumbnail-list li[data-media-id]");
        thumbnails.forEach(thumb => {
            const thumbMediaId = thumb.getAttribute("data-media-id") || "";
            if (visibleMediaIds.some(id => thumbMediaId.includes(id))) {
                thumb.style.setProperty("display", "block", "important");
            } else {
                thumb.style.setProperty("display", "none", "important");
            }
        });

        const sliderButtons = this.querySelector('.slider-buttons');
        const sliderPagination = this.querySelector('.slider-pagination');
        
        if (visibleMediaIds.length <= 1) {
            if (sliderButtons) sliderButtons.style.setProperty("display", "none", "important");
            if (sliderPagination) sliderPagination.style.setProperty("display", "none", "important");
        } else {
            if (sliderButtons) sliderButtons.style.removeProperty("display");
            if (sliderPagination) sliderPagination.style.removeProperty("display");
        }

        // Safe Slider Refresh
        const galleryViewer = this.querySelector('[id^="GalleryViewer-"]');
        if (galleryViewer && typeof galleryViewer.resetPages === "function") {
            setTimeout(() => {
                try {
                    galleryViewer.resetPages();
                } catch (error) {
                    console.log("Slider safely adjusted!");
                }
            }, 50);
        }
      }


      //Live
      // filterVariantImages(variant) {
      //   if (!variant) return;
      //   if (this.dataset.menProduct !== "true") return;
      //   const optionValues = variant.options.map(v =>
      //   v.toLowerCase().replace(/\s+/g, "-")
      //   );
      //   const productTitle = this.dataset.productTitle?.toLowerCase().replace(/\s+/g, "-");
      //   const variantKey = optionValues.join("-");
      //   const mediaGallery = this.querySelector("media-gallery");
      //   if (!mediaGallery) return;
      //   const mediaItems = mediaGallery.querySelectorAll("li[data-media-id].list_media");
      //   mediaItems.forEach(item => item.classList.add("variant-hidden"));
      //   let firstMatch = null;
      //   let imgAlt = null
      //   mediaItems.forEach((item) => {
      //   imgAlt = item.getAttribute("data-variant-media")?.toLowerCase();
      //   if (imgAlt === variantKey ) {
      //     item.classList.remove("variant-hidden");
      //     if (!firstMatch) firstMatch = item;
      //   } 
      //   else {
      //     item.classList.add("variant-hidden");
      //   }
      //     console.log("img_alt:", imgAlt);
      //   });
      //    console.log("variantKey:", variantKey);
      //   // if nothing matched show all images (prevents slider crash)
      //   if (!firstMatch) {
      //    mediaItems.forEach(item => item.classList.remove("variant-hidden"));
      //   }
      // }






      updateSelectedColor(variant) {
        if (!variant) return;
        const langSec = this.querySelector(".lang-sec[data-men-color='true']");
        if (!langSec) return;
        const colorIndex = parseInt(langSec.dataset.colorIndex);
        const productType = langSec.dataset.productType;
        const skuBase = langSec.dataset.skuBase;
        const selectedColor = variant.options[colorIndex];
        if (!selectedColor) return;
        langSec.textContent = `${productType} : ${skuBase} | ${selectedColor}`;
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            const variantInCart = cart.items.some(item => item.id === variantId);
            if (variantInCart) {
              // Variant exists in cart → Show bag button
              document.querySelector('.bagBtn').classList.remove('hidden');
              document.querySelector('.addtocartbtnDiv').classList.add('hidden');
            } else {
              // Variant not in cart → Show add to cart button
              document.querySelector('.bagBtn').classList.add('hidden');
              document.querySelector('.addtocartbtnDiv').classList.remove('hidden');
            }
          })
          .catch(error => console.error('Error checking cart:', error));

      }
     
      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;
        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);
        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
document.querySelectorAll('.bagBtn').forEach(function (btn) {
  btn.addEventListener('click', function (e) {
    e.preventDefault(); // prevent link default if it's <a>
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.classList.add('active');
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  if (window.location.search.includes("variant=")) {
    const cleanUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, cleanUrl);
    // $('.product-form').find('.product-variant-id').val('');
  }
});






// Varient autoselect & changes
document.addEventListener('DOMContentLoaded', function() {
  const productInfo = document.querySelector('product-info');
  if (!productInfo) return;
  const variantsDataNode = document.getElementById(`ProductVariantsData-${productInfo.dataset.section}`);
  if (!variantsDataNode) return;
  
  const allVariants = JSON.parse(variantsDataNode.textContent);
  
  
  let lastSelectedColor = null;
  let isFirstRun = true;

  // function updateSizesSafely() {
  //   const allRadios = Array.from(productInfo.querySelectorAll('input[type="radio"]'));  
  //   let checkedColorValue = null;
  //   let sizeRadios = [];
  //   let checkedSizeRadio = null;

  //   allRadios.forEach(radio => {
  //     const name = radio.name.toLowerCase();
  //     const legend = radio.closest('fieldset')?.querySelector('legend')?.innerText.toLowerCase() || ''; 
  //     if (name.includes('color') || name.includes('colour') || legend.includes('color') || legend.includes('colour')) {
  //       if (radio.checked) checkedColorValue = radio.value.trim();
  //     } else if (name.includes('size') || legend.includes('size')) {
  //       sizeRadios.push(radio);
  //       if (radio.checked) checkedSizeRadio = radio;
  //     }
  //   });

  //   if (!checkedColorValue) return;

   
  //   let colorChanged = false;
  //   if (lastSelectedColor !== checkedColorValue) {
  //     if (lastSelectedColor !== null) {
  //       colorChanged = true; 
  //     }
  //     lastSelectedColor = checkedColorValue;
  //   }

  //   const variantsForColor = allVariants.filter(v => v.options.some(opt => opt && opt.trim() === checkedColorValue));
  //   const validSizes = variantsForColor.flatMap(v => v.options.map(o => o && o.trim()));
    
  //   let checkedSizeIsHidden = false;
  //   let firstAvailableSizeRadio = null;

  //   sizeRadios.forEach(radio => {
  //     const label = productInfo.querySelector(`label[for="${radio.id}"]`);
  //     if (!label) return;

  //     const sizeVal = radio.value.trim();
  //     if (validSizes.includes(sizeVal)) {
  //       label.style.display = 'inline-block';      
  //       if (!firstAvailableSizeRadio) {
  //         const variant = variantsForColor.find(v => v.options.includes(sizeVal) && v.available);
  //         if (variant) firstAvailableSizeRadio = radio;
  //       }
  //     } else {
  //       label.style.display = 'none';
  //       if (radio.checked) {
  //         checkedSizeIsHidden = true; 
  //       }
  //     }
  //   });

  //   if (!firstAvailableSizeRadio) {
  //     firstAvailableSizeRadio = sizeRadios.find(r => validSizes.includes(r.value.trim()));
  //   }  

 
  //   let shouldAutoSelect = false;
  //   if (isFirstRun) {
  //     if (checkedSizeIsHidden) shouldAutoSelect = true;
  //     isFirstRun = false;
  //   } else {
 
  //     if (colorChanged || checkedSizeIsHidden) {
  //       shouldAutoSelect = true;
  //     }
  //   }

  //   // Auto-click the button
  //   if (shouldAutoSelect && firstAvailableSizeRadio && firstAvailableSizeRadio !== checkedSizeRadio) {
  //     firstAvailableSizeRadio.checked = true;
  //     firstAvailableSizeRadio.dispatchEvent(new Event('change', { bubbles: true }));
  //   }
  // }
function updateSizesSafely() {
    const allRadios = Array.from(productInfo.querySelectorAll('input[type="radio"]'));  
    let checkedColorValue = null;
    let sizeRadios = [];
    let currentSelectedSizeValue = null;

    allRadios.forEach(radio => {
      const name = radio.name.toLowerCase();
      const legend = radio.closest('fieldset')?.querySelector('legend')?.innerText.toLowerCase() || ''; 
      if (name.includes('color') || name.includes('colour') || legend.includes('color') || legend.includes('colour')) {
        if (radio.checked) checkedColorValue = radio.value.trim();
      } else if (name.includes('size') || legend.includes('size')) {
        sizeRadios.push(radio);
        if (radio.checked) currentSelectedSizeValue = radio.value.trim(); // Save current size
      }
    });

    if (!checkedColorValue) return;

    // Get all valid sizes for the new color
    const variantsForColor = allVariants.filter(v => v.options.some(opt => opt && opt.trim() === checkedColorValue));
    const validSizes = variantsForColor.flatMap(v => v.options.map(o => o && o.trim()));
    
    let firstAvailableSizeRadio = null;
    let currentSizeIsStillAvailable = false;

    sizeRadios.forEach(radio => {
      const label = productInfo.querySelector(`label[for="${radio.id}"]`);
      if (!label) return;

      const sizeVal = radio.value.trim();
      const isAvailable = validSizes.includes(sizeVal);

      if (isAvailable) {
        label.style.display = 'inline-block';      
        if (sizeVal === currentSelectedSizeValue) {
          currentSizeIsStillAvailable = true; 
        }
        if (!firstAvailableSizeRadio) {
          firstAvailableSizeRadio = radio;
        }
      } else {
        label.style.display = 'none';
      }
    });


    if (!currentSizeIsStillAvailable && firstAvailableSizeRadio) {
      firstAvailableSizeRadio.checked = true;
      firstAvailableSizeRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  updateSizesSafely();

  productInfo.addEventListener('change', function(e) {
    const name = e.target.name ? e.target.name.toLowerCase() : '';
    const legend = e.target.closest('fieldset')?.querySelector('legend')?.innerText.toLowerCase() || '';     
    if (name.includes('color') || name.includes('colour') || legend.includes('color') || legend.includes('colour')) {
       setTimeout(updateSizesSafely, 10);
    }
  });

  const observer = new MutationObserver(() => {
    observer.disconnect(); 
    updateSizesSafely();
    observer.observe(productInfo, { childList: true, subtree: true });
  });
  observer.observe(productInfo, { childList: true, subtree: true });
});


